export const DOMAINS = {
  NO_SUBDOMAIN: 'NO_SUBDOMAIN',
  LOCALHOST: 'LOCALHOST',
  UAT: 'UAT01',
};
